import React, { useEffect, useRef, useState } from "react";
import "./Cart.scss";

import {
  FaPlus,
  FaMinus,
  FaChevronRight,
  FaCartFlatbed,
} from "react-icons/fa6";
import { FaTag } from "react-icons/fa6";
import { FaRegStickyNote } from "react-icons/fa";
import { RiDiscountPercentLine } from "react-icons/ri";
import { MdOutlineRemoveShoppingCart } from "react-icons/md";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { RiEditBoxLine } from "react-icons/ri";
import { FaMoneyBills } from "react-icons/fa6";

import ROUTES from "../../../constants/routes";
import { useDispatch, useSelector } from "react-redux";
import {
  addDeliveryFee,
  addDiscountDetails,
  addItemDiscount,
  addItemToCart,
  addNoteToCheckout,
  clearCart,
  removeItemFromCart,
} from "../../../redux/features/cart-slice";
import Accordian from "../../../components/Accordian/Accordian";
import CustomButton from "../../../components/CustomButton/CustomButton";
import InputField from "../../../components/InputField/InputField";
import InputSelect from "../../../components/InputSelect/InputSelect";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { addDelivery, fetchDeliveries } from "../../../api/delivery";
import { useNavigate } from "react-router-dom";
import useUserIsAllowed from "../../../helpers/userAuthorized";
import { useViewPortDetector } from "../../../helpers/viewPortDetector";
import { storage } from "../../../helpers/storage";
import useOrganizationIsAllowed from "../../../helpers/organizationPrevillages";
import { updateOpenSubscriptionAd } from "../../../redux/features/subscription-slice";
import { addNewDelivery } from "../../../redux/features/organization-slice";

const Cart = ({ desktopView, selectedTab: selectedCheckoutTab }) => {
  const { currentViewPort, isReady } = useViewPortDetector();
  const navigate = useNavigate();

  const {
    items: cartItems,
    subTotalPrice,
    totalPrice,
    tax: tax_amount,
    percent_discount,
    cash_discount,
    delivery_charge,
    tax_rate,
    note,
    totalItems,
    saleId,
  } = useSelector((state) => state.cartReducer.value);
  const { currency, id: organization_id } = useSelector(
    (state) => state.organizationReducer.value
  );
  const { run } = useSelector((state) => state.tourReducer.value);
  const { tour_checkout } = useSelector((state) => state.userReducer.value);

  const isAllowedToGiveDiscount = useUserIsAllowed("give_discounts");

  const orgIsAllowedToGiveBulkDiscount =
    useOrganizationIsAllowed("bulk_discount");

  const [selectedItem, setSelectedItem] = useState(null);
  const [openItemDiscount, setOpenItemDiscount] = useState(false);

  const [openCreateDelivery, setOpenCreateDelivery] = useState(false);

  useEffect(() => {
    if (!desktopView) {
      if (currentViewPort === "desktop" && isReady) {
        navigate(ROUTES.checkout.path);
      }
    }
  }, [currentViewPort, desktopView, isReady]);

  useEffect(() => {
    if (desktopView && selectedCheckoutTab) {
      setSelectedtab("");
      setOpenItemDiscount(false);
    }
  }, [selectedCheckoutTab, desktopView]);

  useEffect(() => {
    if (cartItems?.length <= 0 && !(run && tour_checkout)) {
      if (!desktopView) {
        navigate(ROUTES.checkout.path);
      }
    }
  }, [cartItems]);

  const dispatch = useDispatch();

  const handleQuanityIncrease = async (item) => {
    let itemData = {};
    if (item?.nonInventory) {
      itemData = {
        newItem: {
          ...item,
          product: {
            ...item?.product,
            quantity: 1,
          },
          quantity: 1,
        },
      };
    } else {
      itemData = {
        newItem: {
          ...item,
          quantity: 1,
        },
      };
    }

    let prev_items = await storage.get("cart");
    prev_items = prev_items ? JSON.parse(prev_items) : [];

    const exists = prev_items?.findIndex(
      (el) => el?.newItem?.product?.id === itemData?.newItem?.product?.id
    );

    if (exists !== -1) {
      if (!item?.nonInventory) {
        prev_items[exists].newItem.quantity += 1;
      } else {
        prev_items[exists].newItem.product.quantity += 1;
      }
    }
    storage.set("cart", JSON.stringify(prev_items));
    dispatch(addItemToCart(itemData));
  };

  const handleQuanityDecrease = async (item) => {
    if (saleId && totalItems === 1) {
      toast.dismiss();
      toast.error("Order sale must have atleast one item!");
    } else {
      const itemData = {
        newItem: item,
      };

      let prev_items = await storage.get("cart");
      prev_items = prev_items ? JSON.parse(prev_items) : [];

      const exists = prev_items?.findIndex(
        (el) => el?.newItem?.product?.id === itemData?.newItem?.product?.id
      );

      if (exists !== -1) {
        if (!item?.nonInventory) {
          if (prev_items[exists].newItem.quantity === 1) {
            prev_items.splice(exists, 1);
          } else {
            prev_items[exists].newItem.quantity -= 1;
          }
        } else {
          if (prev_items[exists].newItem.product.quantity === 1) {
            prev_items.splice(exists, 1);
          } else {
            prev_items[exists].newItem.product.quantity += 1;
          }
        }
      }

      storage.set("cart", JSON.stringify(prev_items));
      dispatch(removeItemFromCart(itemData));
    }
  };

  const [selectedTab, setSelectedtab] = useState("");

  const handleClearCart = () => {
    storage.remove("cart");
    dispatch(clearCart());
  };

  const handleNext = () => {
    navigate(ROUTES.payment.path);
  };

  const clearDiscount = () => {
    const itemData = {
      cash_discount: 0,
      percent_discount: 0,
      totalPrice: Number(
        Number(subTotalPrice) + Number(tax_amount) + Number(delivery_charge)
      ).toFixed(2),
    };
    dispatch(addDiscountDetails(itemData));
  };

  return (
    <div className="checkout-cart">
      <div className="container-wrapper page-contents">
        <div className="cart-list">
          <div className="table-grid">
            <div className="headings">
              <p
                style={{
                  width: "100%",
                  textAlign: "left",
                  paddingLeft: "24px",
                }}
              >
                Product
              </p>
              <p>Quantity</p>
              <p
                style={{
                  width: "100%",
                  textAlign: "right",
                  paddingRight: "24px",
                }}
              >
                Total
              </p>
            </div>
            {cartItems.map((item, i) => {
              return (
                <CartItems
                  key={i}
                  item={item}
                  selectedItem={selectedItem}
                  setSelectedItem={setSelectedItem}
                  currency={currency}
                  handleQuanityDecrease={handleQuanityDecrease}
                  handleQuanityIncrease={handleQuanityIncrease}
                  setOpenItemDiscount={setOpenItemDiscount}
                  isAllowedToGiveDiscount={isAllowedToGiveDiscount}
                />
              );
            })}
          </div>

          <div className="overall-calc">
            {tax_amount > 0 && (
              <p>
                Tax: {currency}
                {tax_amount}
              </p>
            )}
            {cash_discount > 0 ? (
              <div className="discount-container">
                <p
                  className="danger"
                  onClick={() => {
                    if (orgIsAllowedToGiveBulkDiscount) {
                      if (isAllowedToGiveDiscount) {
                        setSelectedtab("discount");
                      } else {
                        toast.dismiss();
                        toast.info(
                          "You do not have sufficient permissions to perform this action. Please contact your administrator."
                        );
                      }
                    } else {
                      dispatch(updateOpenSubscriptionAd({ openAd: true }));
                    }
                  }}
                >
                  Discount{`(${percent_discount}%)`}: {currency}
                  {cash_discount}
                </p>
                <IoIosCloseCircleOutline
                  onClick={() => {
                    if (isAllowedToGiveDiscount) {
                      clearDiscount();
                    } else {
                      toast.dismiss();
                      toast.info(
                        "You do not have sufficient permissions to perform this action. Please contact your administrator."
                      );
                    }
                  }}
                />
              </div>
            ) : (
              <p
                className="link"
                onClick={() => {
                  if (orgIsAllowedToGiveBulkDiscount.exists) {
                    if (isAllowedToGiveDiscount) {
                      setSelectedtab("discount");
                    } else {
                      toast.dismiss();
                      toast.info(
                        "You do not have sufficient permissions to perform this action. Please contact your administrator."
                      );
                    }
                  } else {
                    dispatch(updateOpenSubscriptionAd({ openAd: true }));
                  }
                }}
                id="tour-cart-discount"
              >
                Add Discount
              </p>
            )}
            {delivery_charge > 0 && (
              <p>
                Delivery Fee: {currency}
                {delivery_charge}
              </p>
            )}
            <h1>
              TOTAL:{" "}
              <span>
                {currency}
                {totalPrice}
              </span>
            </h1>
          </div>
        </div>

        <div className="custom-accordian-wrapper">
          <Accordian
            name={"More Options"}
            initial={false}
            id={"tour-more-options"}
          >
            <div className="more-options">
              <div
                className="selector border-bottom"
                onClick={() => {
                  setSelectedtab("delivery");
                }}
              >
                <p>
                  <FaCartFlatbed /> Delivery Fee
                </p>{" "}
                <FaChevronRight />
              </div>
              <div
                className="selector border-bottom"
                onClick={() => {
                  setSelectedtab("note");
                }}
              >
                <p>
                  <FaRegStickyNote /> Add Note{" "}
                  {note && (
                    <span>
                      <RiEditBoxLine />
                    </span>
                  )}
                </p>
                <FaChevronRight />
              </div>
              <div
                className="selector border-bottom"
                onClick={() => {
                  if (orgIsAllowedToGiveBulkDiscount.exists) {
                    if (isAllowedToGiveDiscount) {
                      setSelectedtab("discount");
                    } else {
                      toast.dismiss();
                      toast.info(
                        "You do not have sufficient permissions to perform this action. Please contact your administrator."
                      );
                    }
                  } else {
                    dispatch(updateOpenSubscriptionAd({ openAd: true }));
                  }
                }}
              >
                <p>
                  <RiDiscountPercentLine /> Add Discount
                </p>
                <FaChevronRight />
              </div>
              <div className="selector" onClick={handleClearCart}>
                <p className="danger">
                  <MdOutlineRemoveShoppingCart /> Clear Cart
                </p>
              </div>
            </div>
          </Accordian>
        </div>
      </div>
      <div className="floating-button">
        <CustomButton
          name={`${totalItems} items = ${currency}${totalPrice}`}
          type={"button"}
          color={"primary"}
          bigButton={true}
          handleSubmit={handleNext}
          id={"tour-next-to-pay"}
        />
      </div>

      <AddDeliveryFee
        selectedTab={selectedTab}
        setSelectedtab={setSelectedtab}
        delivery_charge={delivery_charge}
        dispatch={dispatch}
        organization_id={organization_id}
        currency={currency}
        setOpenCreateDelivery={setOpenCreateDelivery}
      />

      <AddNote
        selectedTab={selectedTab}
        setSelectedtab={setSelectedtab}
        note={note}
        dispatch={dispatch}
      />

      <AddDiscount
        selectedTab={selectedTab}
        setSelectedtab={setSelectedtab}
        amount={cash_discount}
        percent={percent_discount}
        subTotalPrice={subTotalPrice}
        tax_amount={tax_amount}
        delivery_charge={delivery_charge}
        currency={currency}
        dispatch={dispatch}
      />

      <ItemDiscount
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        dispatch={dispatch}
        open={openItemDiscount}
        setOpen={setOpenItemDiscount}
      />

      <CreateDeliveryFee
        open={openCreateDelivery}
        setOpen={setOpenCreateDelivery}
        organization_id={organization_id}
      />

      {(selectedTab || openItemDiscount) && (
        <div
          className="blur-back"
          onClick={() => {
            setSelectedtab("");
            setSelectedItem(null);
            setOpenItemDiscount(false);
          }}
        ></div>
      )}

      {openCreateDelivery && (
        <div
          className="blur-back upper"
          onClick={() => {
            setOpenCreateDelivery(false);
          }}
        ></div>
      )}
    </div>
  );
};

export default Cart;

const CartItems = ({
  item,
  selectedItem,
  setSelectedItem,
  currency,
  handleQuanityDecrease,
  handleQuanityIncrease,
  setOpenItemDiscount,
  isAllowedToGiveDiscount,
}) => {
  const itemRef = useRef();

  const itemName = item?.product?.name || "(No Description)";
  const itemPrice =
    item?.product?.reduced_price > 0
      ? item?.product?.reduced_price
      : item?.product?.price;
  const itemQuantity = item?.nonInventory
    ? item?.product?.quantity
    : item?.quantity;

  const itemBasePrice =
    item?.product?.base_price > 0
      ? Number(item?.product?.base_price)
      : itemPrice;

  const itemTotalPrice = Number(
    itemQuantity * itemBasePrice - Number(item?.discount || 0)
  ).toFixed(2);
  const active = selectedItem
    ? selectedItem?.product?.id === item?.product?.id
    : true;
  const selected = selectedItem?.product?.id === item?.product?.id;

  useEffect(() => {
    if (selected) {
      if (itemRef.current) {
        itemRef.current.style.maxHeight = "100" + "px";
      }
    } else {
      if (itemRef.current) {
        itemRef.current.style.maxHeight = "0px";
      }
    }
  }, [itemRef, selected]);
  return (
    <>
      <div
        className={`item-row ${active ? "active" : ""}`}
        onClick={() => {
          if (!selectedItem) {
            setSelectedItem(item);
          } else {
            setSelectedItem(null);
          }
        }}
      >
        <div className="content">
          <p className="name">{itemName}</p>
          <p className="price">
            {currency}
            {itemPrice}
          </p>
        </div>
        <div
          className="quantity"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <p
            className="minus"
            onClick={() => {
              if (active) {
                handleQuanityDecrease(item);
              } else {
                setSelectedItem(null);
              }
            }}
          >
            <FaMinus />
          </p>
          <p>{itemQuantity}</p>
          <p
            className="plus"
            onClick={() => {
              if (active) {
                handleQuanityIncrease(item);
              } else {
                setSelectedItem(null);
              }
            }}
          >
            <FaPlus />
          </p>
        </div>
        <div className="total">
          <p>
            {currency}
            {itemTotalPrice}
          </p>
          {item?.discount && <FaTag />}
        </div>
      </div>
      <div className={`item-options ${selected ? "active" : ""}`} ref={itemRef}>
        <div className="left">
          <p>
            <span>x</span> {itemQuantity}
          </p>
        </div>
        <div className="right">
          <p className="money">
            <FaMoneyBills />
            Change Price
          </p>
          <p
            className="discount"
            onClick={() => {
              if (isAllowedToGiveDiscount) {
                setOpenItemDiscount(true);
              } else {
                toast.dismiss();
                toast.info(
                  "You do not have sufficient permissions to perform this action. Please contact your administrator."
                );
              }
            }}
          >
            <RiDiscountPercentLine />
            {item?.discount > 0
              ? `${currency}${item?.discount}`
              : "Add Discount"}
          </p>
        </div>
      </div>
    </>
  );
};

const CreateDeliveryFee = ({ open, setOpen, organization_id }) => {
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = useState(false);
  const userIsAdministrator = useUserIsAllowed("administrator");
  const userIsAllowedToManageInventory = useUserIsAllowed("manage_inventory");

  const userIsAllowedToAddEditDelivery =
    userIsAdministrator || userIsAllowedToManageInventory;
  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  const handleAddDelivery = (data) => {
    const deliveryData = {
      name: data?.name,
      amount: data?.amount,
      organization_id: organization_id,
    };

    setSubmitting(true);

    addDelivery(organization_id, deliveryData)
      .then((res) => {
        dispatch(addNewDelivery({ delivery: res.data }));
        toast.dismiss();
        toast.success("New delivery rate created.");
        setOpen(false);
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          if (err?.response?.data?.message === "User not authorized!") {
            toast.dismiss();
            toast.error(
              "You do not have sufficient permissions to perform this action. Please contact your administrator."
            );
          } else {
            toast.dismiss();
            toast.error(`${err?.response?.data?.message}`);
          }
        } else {
          toast.dismiss();
          toast.error("Error while adding delivery rate!");
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  useEffect(() => {
    if (open) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [open, isVisible]);

  if (!shouldRender) return null;

  return (
    <form
      aria-disabled={!userIsAllowedToAddEditDelivery}
      onSubmit={handleSubmit(handleAddDelivery)}
      className={`create-delivery-fee ${isVisible ? "active" : ""}`}
    >
      <h1 className="heading">
        <FaCartFlatbed /> Create Delivery Fee
      </h1>
      <div className="form-content delivery">
        <InputField
          name={"name"}
          type={"text"}
          label={"Delivery Name*"}
          required={true}
          register={register}
          inputErrors={errors}
          watch={watch}
          disabled={!userIsAllowedToAddEditDelivery}
        />

        <InputField
          name={"amount"}
          type={"number"}
          label={"Amount*"}
          required={true}
          register={register}
          inputErrors={errors}
          watch={watch}
          constraints={{
            min: 0,
          }}
          disabled={!userIsAllowedToAddEditDelivery}
        />
      </div>
      <div className="buttons">
        <CustomButton
          name={"Cancel"}
          color={"danger"}
          type={"button"}
          handleSubmit={() => {
            setOpen(false);
          }}
          disabled={submitting}
        />

        <CustomButton
          name={"Create Delivery Fee"}
          color={"primary"}
          type={"submit"}
          handleSubmit={() => {}}
          disabled={submitting || !userIsAllowedToAddEditDelivery}
          loader={submitting}
        />
      </div>
    </form>
  );
};

const AddDeliveryFee = ({
  selectedTab,
  setSelectedtab,
  delivery_charge,
  dispatch,
  currency,
  setOpenCreateDelivery,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [submitting, setSubmitting] = useState(false);
  const [selectedOption, setSelectedOption] = useState({});
  const [options, setOptions] = useState([]);

  const { deliveries } = useSelector(
    (state) => state.organizationReducer.value
  );

  const handleAddDeliveryFee = (data) => {
    setSubmitting(true);
    const itemData = {
      delivery_charge: selectedOption?.value || 0.0,
    };
    dispatch(addDeliveryFee(itemData));
    setSelectedtab("");
    toast.dismiss();
    toast.success(`Delivery fee added.`);
    setSubmitting(false);
  };

  useEffect(() => {
    const deliveryOptions = [
      {
        label: "No Delivery Charge",
        value: 0.0,
      },
    ];
    deliveries?.map((item) => {
      deliveryOptions.push({
        label: `${item?.name} - ${currency}${item?.amount}`,
        value: item?.amount,
      });
    });

    deliveryOptions.push({
      label: "Add Delivery Fee",
      value: "",
      isButton: true,
      handleClick: () => {
        setOpenCreateDelivery(true);
      },
    });

    setOptions(deliveryOptions);
    setSelectedOption(deliveryOptions[0]);
  }, [deliveries]);

  useEffect(() => {
    if (selectedTab === "delivery") {
      let selectedOpt = options.find((el) => el?.amount === delivery_charge);

      if (selectedOpt) {
        setSelectedOption(selectedOpt);
      }
    }
  }, [selectedTab, options]);

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (selectedTab === "delivery") {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [selectedTab, isVisible]);

  if (!shouldRender) return null;

  return (
    <form
      disabled={submitting}
      onSubmit={handleSubmit(handleAddDeliveryFee)}
      className={`add-options ${isVisible ? "active" : ""}`}
    >
      <h1 className="heading">
        <FaCartFlatbed /> Delivery Fee
      </h1>

      <div className="form-content delivery">
        <InputSelect
          options={options}
          value={selectedOption}
          register={register}
          required={true}
          name="delivery_charge"
          handleChange={(opt) => {
            if (opt?.label !== "Add Delivery Fee") {
              setSelectedOption(opt);
            }
          }}
          reset={reset}
          label={"Delivery"}
          inputErrors={errors}
        />
      </div>

      <div className="buttons">
        <CustomButton
          name={"Cancel"}
          color={"danger"}
          type={"button"}
          handleSubmit={() => {
            setSelectedtab("");
          }}
          disabled={submitting}
        />

        <CustomButton
          name={"Apply Delivery Fee"}
          color={"primary"}
          type={"submit"}
          handleSubmit={() => {}}
          disabled={submitting}
          loader={submitting}
        />
      </div>
    </form>
  );
};

const AddNote = ({ selectedTab, setSelectedtab, note, dispatch }) => {
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm();

  const [submitting, setSubmitting] = useState(false);

  const handleAddNote = (data) => {
    setSubmitting(true);
    const itemData = {
      note: data.note,
    };
    dispatch(addNoteToCheckout(itemData));
    setSelectedtab("");
    toast.dismiss();
    toast.success(`Note added.`);
    setSubmitting(false);
  };

  useEffect(() => {
    if (selectedTab === "note") {
      reset({
        note: note,
      });
    }
  }, [selectedTab]);

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (selectedTab === "note") {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [selectedTab, isVisible]);

  if (!shouldRender) return null;

  return (
    <form
      disabled={submitting}
      onSubmit={handleSubmit(handleAddNote)}
      className={`add-options ${isVisible ? "active" : ""}`}
    >
      <h1 className="heading">
        <FaRegStickyNote /> Add Note
      </h1>

      <div className="form-content">
        <InputField
          name={"note"}
          type={"text"}
          label={"Note"}
          required={true}
          register={register}
          inputErrors={errors}
          textArea={true}
          watch={watch}
        />
      </div>

      <div className="buttons">
        <CustomButton
          name={"Cancel"}
          color={"danger"}
          type={"button"}
          handleSubmit={() => {
            setSelectedtab("");
          }}
          disabled={submitting}
        />

        <CustomButton
          name={"Apply Note"}
          color={"primary"}
          type={"submit"}
          handleSubmit={() => {}}
          disabled={submitting}
          loader={submitting}
        />
      </div>
    </form>
  );
};

const AddDiscount = ({
  selectedTab,
  setSelectedtab,
  amount,
  percent,
  subTotalPrice,
  tax_amount,
  delivery_charge,
  currency,
  dispatch,
}) => {
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm();

  const [subTotal, setSubTotal] = useState(subTotalPrice);
  const [total, setTotal] = useState(
    (
      Number(subTotalPrice) +
      Number(tax_amount) +
      Number(delivery_charge) -
      Number(amount)
    ).toFixed(2)
  );

  const [discountAmount, setDiscountAmount] = useState(amount);
  const [discountPercent, setDiscountPercent] = useState(percent);

  const [initialAmount, setInitialAmount] = useState(true);
  const [initialPercent, setInitialPercent] = useState(true);

  const [submitting, setSubmitting] = useState(false);

  const handleApplyDiscount = (data) => {
    setSubmitting(true);
    const itemData = {
      cash_discount: Number(discountAmount).toFixed(2),
      percent_discount: Number(discountPercent).toFixed(2),
      totalPrice: Number(total).toFixed(2),
    };
    dispatch(addDiscountDetails(itemData));
    setSelectedtab("");
    toast.dismiss();
    toast.success(`Discount Applied.`);
    setSubmitting(false);
  };

  useEffect(() => {
    if (selectedTab === "discount") {
      setSubTotal(subTotalPrice);
      setTotal(
        (
          Number(subTotalPrice) +
          Number(tax_amount) +
          Number(delivery_charge) -
          Number(amount)
        ).toFixed(2)
      );
      if (!(amount > 0)) {
        setInitialAmount(true);
      } else {
        setInitialAmount(false);
      }
      if (!(percent > 0)) {
        setInitialPercent(true);
      } else {
        setInitialPercent(false);
      }
      setDiscountAmount(amount);
      setDiscountPercent(percent);
    }
  }, [selectedTab]);

  const handleAmountChange = (data) => {
    let data_value = data;

    if (initialAmount) {
      setInitialAmount(false);
      let significantPart = Math.abs(data).toString().replace(".", "");
      significantPart = Math.abs(significantPart).toString().replace("0", "");
      data_value = significantPart;
    }

    setTotal(
      (
        Number(subTotalPrice) +
        Number(tax_amount) +
        Number(delivery_charge) -
        Number(data_value)
      ).toFixed(2)
    );

    const calc_dis_per = (
      (Number(data_value) / Number(subTotalPrice)) *
      100
    ).toFixed(2);
    if (!(calc_dis_per > 0)) {
      setInitialPercent(true);
    } else {
      setInitialPercent(false);
    }
    setDiscountPercent(calc_dis_per);
    setDiscountAmount(data_value);
  };

  const handlePercentChange = (data) => {
    let data_value = data;

    if (initialPercent) {
      setInitialPercent(false);
      let significantPart = Math.abs(data).toString().replace(".", "");
      significantPart = Math.abs(significantPart).toString().replace("0", "");
      data_value = significantPart;
    }

    const calc_dis_amt = (
      (Number(data_value) * Number(subTotalPrice)) /
      100
    ).toFixed(2);

    if (!(calc_dis_amt > 0)) {
      setInitialAmount(true);
    } else {
      setInitialAmount(false);
    }

    setTotal(
      (
        Number(subTotalPrice) +
        Number(tax_amount) +
        Number(delivery_charge) -
        Number(calc_dis_amt)
      ).toFixed(2)
    );

    setDiscountPercent(data_value);
    setDiscountAmount(calc_dis_amt);
  };

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (selectedTab === "discount") {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [selectedTab, isVisible]);

  if (!shouldRender) return null;

  return (
    <form
      disabled={submitting}
      onSubmit={handleSubmit(handleApplyDiscount)}
      className={`add-options item-discount-model ${isVisible ? "active" : ""}`}
    >
      <h1 className="heading">
        <RiDiscountPercentLine /> Add Discount
      </h1>

      <div className="form-content">
        <p className="title">Cash Discount</p>
        <InputField
          name={"amount"}
          type={"number"}
          label={"Amount"}
          required={true}
          register={register}
          inputErrors={errors}
          watch={watch}
          value={discountAmount}
          handleChange={(data) => {
            handleAmountChange(data);
          }}
          constraints={{
            min: 0,
            max: subTotalPrice,
          }}
        />

        <p className="title">Percent Discount</p>

        <InputField
          name={"percent"}
          type={"number"}
          label={"Percent"}
          required={true}
          register={register}
          inputErrors={errors}
          watch={watch}
          value={discountPercent}
          handleChange={(data) => {
            handlePercentChange(data);
          }}
          constraints={{
            min: 0,
            max: 100,
          }}
        />

        <p className="details">
          Sub Total: <br />
          <span>
            {currency} {subTotal}
          </span>
        </p>

        <p className="details danger-texts">
          Discount{`(${discountPercent}%)`}: <br />
          <span>
            - {currency}
            {discountAmount}
          </span>
        </p>

        <p className="details">
          Total: <br />
          <span className="success-texts">
            {currency}
            {total}
          </span>
        </p>
      </div>

      <div className="buttons">
        <CustomButton
          name={"Cancel"}
          color={"danger"}
          type={"button"}
          handleSubmit={() => {
            setSelectedtab("");
          }}
          disabled={submitting}
        />

        <CustomButton
          name={"Apply Discount"}
          color={"primary"}
          type={"submit"}
          handleSubmit={() => {}}
          disabled={submitting}
          loader={submitting}
        />
      </div>
    </form>
  );
};

const ItemDiscount = ({
  selectedItem,
  setSelectedItem,
  dispatch,
  open,
  setOpen,
}) => {
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm();
  const [itemTotalPrice, setItemTotalPrice] = useState(0);

  const [discountAmount, setDiscountAmount] = useState(0);
  const [discountPercent, setDiscountPercent] = useState(0);

  const [initialAmount, setInitialAmount] = useState(true);
  const [initialPercent, setInitialPercent] = useState(true);

  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (selectedItem) {
      const itemPrice =
        selectedItem?.product?.reduced_price > 0
          ? selectedItem?.product?.reduced_price
          : selectedItem?.product?.price;

      const itemQuantity = selectedItem?.nonInventory
        ? selectedItem?.product?.quantity
        : selectedItem?.quantity;

      const totalItemPrice = Number(itemPrice * itemQuantity).toFixed(2);

      setItemTotalPrice(Number(itemPrice * itemQuantity).toFixed(2));
      setDiscountAmount(selectedItem?.discount);
      let per = Number(
        (Number(selectedItem?.discount || 0) / totalItemPrice) * 100
      ).toFixed(2);

      setDiscountPercent(per);

      if (selectedItem?.discount) {
        setInitialAmount(false);
        setInitialPercent(false);
      } else {
        setInitialAmount(true);
        setInitialPercent(true);
      }
    } else {
      setItemTotalPrice(0);
      setDiscountAmount(0);
      setDiscountPercent(0);
      setInitialAmount(true);
      setInitialPercent(true);
    }
  }, [selectedItem, open]);
  const handleAmountChange = (data) => {
    let data_value = data;

    if (initialAmount) {
      setInitialAmount(false);
      let significantPart = Math.abs(data).toString().replace(".", "");
      significantPart = Math.abs(significantPart).toString().replace("0", "");
      data_value = significantPart;
    }

    const calc_dis_per = (
      (Number(data_value) / Number(itemTotalPrice)) *
      100
    ).toFixed(2);
    if (!(calc_dis_per > 0)) {
      setInitialPercent(true);
    } else {
      setInitialPercent(false);
    }
    setDiscountPercent(calc_dis_per);
    setDiscountAmount(data_value);
  };

  const handlePercentChange = (data) => {
    let data_value = data;

    if (initialPercent) {
      setInitialPercent(false);
      let significantPart = Math.abs(data).toString().replace(".", "");
      significantPart = Math.abs(significantPart).toString().replace("0", "");
      data_value = significantPart;
    }

    const calc_dis_amt = (
      (Number(data_value) * Number(itemTotalPrice)) /
      100
    ).toFixed(2);

    if (!(calc_dis_amt > 0)) {
      setInitialAmount(true);
    } else {
      setInitialAmount(false);
    }

    setDiscountPercent(data_value);
    setDiscountAmount(calc_dis_amt);
  };

  const handleApplyItemDiscount = (data) => {
    const itemData = {
      item: selectedItem,
      discount: discountAmount,
    };

    dispatch(addItemDiscount(itemData));
    setSelectedItem(null);
    setOpen(false);
  };

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (open) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [open, isVisible]);

  if (!shouldRender) return null;
  return (
    <form
      disabled={submitting}
      onSubmit={handleSubmit(handleApplyItemDiscount)}
      className={`add-options item-discount-model ${isVisible ? "active" : ""}`}
    >
      <h1 className="heading">
        <RiDiscountPercentLine /> Add Item Discount
      </h1>

      <div className="form-content">
        <p className="title">Cash Discount</p>
        <InputField
          name={"amount"}
          type={"number"}
          label={"Amount"}
          required={true}
          register={register}
          inputErrors={errors}
          watch={watch}
          value={discountAmount}
          handleChange={(data) => {
            handleAmountChange(data);
          }}
          constraints={{
            min: 0,
            max: itemTotalPrice,
          }}
        />

        <p className="title">Percent Discount</p>

        <InputField
          name={"percent"}
          type={"number"}
          label={"Percent"}
          required={true}
          register={register}
          inputErrors={errors}
          watch={watch}
          value={discountPercent}
          handleChange={(data) => {
            handlePercentChange(data);
          }}
          constraints={{
            min: 0,
            max: 100,
          }}
        />
      </div>

      <div className="buttons">
        <CustomButton
          name={"Cancel"}
          color={"danger"}
          type={"button"}
          handleSubmit={() => {
            setOpen(false);
          }}
          disabled={submitting}
        />

        <CustomButton
          name={"Apply Discount"}
          color={"primary"}
          type={"submit"}
          handleSubmit={() => {}}
          disabled={submitting}
          loader={submitting}
        />
      </div>
    </form>
  );
};
